import React from 'react';

import PanelSelectListing, {
    AttributeStateNameMapping,
    createAttributeMap,
    SyiPanelAttribute,
} from './panel-select-list';
import { FashionAttributes, PanelAttributesComponent } from '@gumtree/shared/src/types/attributes';

type FashionAttribute = FashionAttributes['key'];

const generateAttributeMap = createAttributeMap('fashion');

const FashionAttributeStateNameMapping: { [key in FashionAttribute]: AttributeStateNameMapping } = {
    common_for_sale_condition: generateAttributeMap('condition', { required: true }),
    common_for_sale_colour: generateAttributeMap('colour', {
        defaultValue: 'other',
    }),
    common_for_sale_material: generateAttributeMap('material', { defaultValue: 'other' }),
    fashion_brand: generateAttributeMap('brand', { defaultValue: 'other' }),
    common_for_sale_gender: generateAttributeMap('gender', { required: true }),
    kid_age: generateAttributeMap('kid_age', { required: true }),
    kid_age_optional: generateAttributeMap('kid_age_optional', { defaultValue: 'other' }),
    baby_age: generateAttributeMap('baby_age', { required: true }),
    male_shoe_size: generateAttributeMap('male_shoe_size', { required: true }),
    female_shoe_size: generateAttributeMap('female_shoe_size', { required: true }),
    female_clothing_size: generateAttributeMap('female_clothing_size', { required: true }),
    female_bra_size: generateAttributeMap('female_bra_size', { required: true }),
    male_clothing_size: generateAttributeMap('male_clothing_size', { required: true }),
    male_formal_shirt_size: generateAttributeMap('male_formal_shirt_size', {
        required: true,
    }),
    male_suit_size: generateAttributeMap('male_suit_size', { required: true }),
    male_coat_size: generateAttributeMap('male_coat_size', { required: true }),
    male_tourser_waist_size: generateAttributeMap('male_tourser_waist_size', {
        required: true,
    }),
    male_short_size: generateAttributeMap('male_short_size', { required: true }),
    accessory_size: generateAttributeMap('accessory_size', { defaultValue: 'other' }),
    male_tourser_length: generateAttributeMap('male_tourser_length', { defaultValue: 'other' }),
    baby_shoe_size: generateAttributeMap('baby_shoe_size', { required: true }),
    kid_shoe_size: generateAttributeMap('kid_shoe_size', { required: true }),
    male_suit_waist_size: generateAttributeMap('male_suit_waist_size', { defaultValue: 'other' }),
};

export const FashionAttributeKeys = Object.keys(FashionAttributeStateNameMapping);
interface Props {
    panelName: string;
    panelAttributes: {
        [panelName: string]: SyiPanelAttribute<FashionAttribute>;
    };
}

const FashionPanel: PanelAttributesComponent<Props> = (props: Props) => {
    return (
        <PanelSelectListing<FashionAttribute>
            {...props}
            hideTitle
            attributeStateNameMapping={FashionAttributeStateNameMapping}
            attribute="fashion-condition"
        />
    );
};

export default FashionPanel;
